export const MENTIONS_META = {
  title: 'Mentions Légales — Shynea',
  version: '1.0',
  effectiveDate: '1er juillet 2026',
  publisher: 'Shynea',
  contact: 'contact@shynea.one',
  support: 'support@shynea.one',
};

export const MENTIONS_SECTIONS = [
  {
    id: 'editeur',
    title: '1. Éditeur du site et de la Plateforme',
    paragraphs: [
      'La Plateforme Shynea (sites, applications web et mobiles, minisites et API associés) est éditée par :',
      'Dénomination : Shynea [à compléter : forme juridique — SARL / SAS / SUARL]',
      'Siège social : Dakar, République du Sénégal — [adresse complète à compléter]',
      'NINEA : [à compléter] — RCCM : [à compléter]',
      'Capital social : [à compléter] FCFA',
      'E-mail : contact@shynea.one — Support : support@shynea.one',
      'Directeur de la publication : [nom à compléter]',
    ],
  },
  {
    id: 'hebergeur',
    title: '2. Hébergement',
    paragraphs: [
      'Les services sont hébergés par le(s) prestataire(s) d\'infrastructure cloud / serveur utilisés par Shynea.',
      'Hébergeur : [nom et adresse de l\'hébergeur à compléter]',
      'Pour toute question technique relative à l\'hébergement, contactez support@shynea.one.',
    ],
  },
  {
    id: 'activite',
    title: '3. Nature de l\'activité',
    paragraphs: [
      'Shynea est une plateforme numérique de mise en relation entre Clients et Prestataires (salons, instituts) pour la découverte, la réservation et la gestion de prestations de beauté et bien-être, ainsi que le traitement d\'acomptes via des prestataires de paiement tiers.',
      'Shynea n\'est pas elle-même prestataire des soins réservés. Les Conditions Générales d\'Utilisation précisent le rôle d\'intermédiaire et les responsabilités de chaque partie.',
    ],
  },
  {
    id: 'pi',
    title: '4. Propriété intellectuelle',
    paragraphs: [
      'La marque Shynea, les logos, interfaces, textes, bases de données et éléments graphiques sont protégés. Toute reproduction non autorisée est interdite.',
      'Les contenus publiés par les Utilisateurs (photos, avis, descriptions) restent sous leur responsabilité ; une licence d\'usage est accordée à Shynea conformément aux CGU.',
    ],
  },
  {
    id: 'donnees',
    title: '5. Données personnelles',
    paragraphs: [
      'Le traitement des données personnelles est décrit dans la Politique de Confidentialité, accessible sur la Plateforme (/confidentialite).',
      'Conformément à la Loi n° 2008-12 et aux textes de la CDP, les Utilisateurs disposent de droits d\'accès, rectification, opposition et suppression, dans les conditions prévues par la réglementation.',
    ],
  },
  {
    id: 'cookies',
    title: '6. Cookies',
    paragraphs: [
      'La Plateforme peut utiliser des cookies nécessaires au fonctionnement et, le cas échéant, des cookies de mesure d\'audience. Les détails figurent dans la Politique de Confidentialité.',
    ],
  },
  {
    id: 'responsabilite',
    title: '7. Limitation de responsabilité',
    paragraphs: [
      'L\'éditeur s\'efforce d\'assurer l\'accessibilité et la sécurité de la Plateforme, sans garantie d\'une disponibilité ininterrompue. Les limitations de responsabilité détaillées figurent dans les CGU.',
      'Les Prestataires sont seuls responsables des prestations qu\'ils proposent et réalisent.',
    ],
  },
  {
    id: 'droit',
    title: '8. Droit applicable',
    paragraphs: [
      'Les présentes Mentions Légales sont régies par le droit sénégalais. En cas de litige, et à défaut d\'accord amiable, les juridictions compétentes du ressort de Dakar sont saisies, sous réserve des dispositions impératives protectrices des consommateurs.',
    ],
  },
  {
    id: 'contact',
    title: '9. Contact',
    paragraphs: [
      'contact@shynea.one — support@shynea.one — Dakar, Sénégal.',
    ],
  },
];
